export default __webpack_public_path__ + "static/media/logotype_filled_black.6eb5e15c.svg";